import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProofSection } from '../components/ProofSection';
import { ProblemSection } from '../components/ProblemSection';
import { SystemSection } from '../components/SystemSection';
import { ModulesSection } from '../components/ModulesSection';
import { BonusSection } from '../components/BonusSection';
import { UrgencySection } from '../components/UrgencySection';
import { PricingSection } from '../components/PricingSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { PurchasePopup } from '../components/PurchasePopup';
interface LandingPageProps {
  showPurchaseNotifications: boolean;
  showUrgencySection: boolean;
}
export function LandingPage({
  showPurchaseNotifications,
  showUrgencySection
}: LandingPageProps) {
  return <main className="min-h-screen w-full overflow-hidden bg-white" data-id="element-247" data-mp="2zkruoydmbe56">
      <HeroSection data-id="element-248" data-mp="33lk4ptubdn2i" />
      <ProofSection data-id="element-249" data-mp="33l1x6127bmfa" />
      <ProblemSection data-id="element-250" data-mp="33ifp80bef4wj" />
      <SystemSection data-id="element-251" data-mp="38jvek4klzxkq" />
      <ModulesSection data-id="element-252" data-mp="38jd689ko9swg" />
      <BonusSection data-id="element-253" data-mp="38i26ckucl5am" />
      {showUrgencySection && <UrgencySection data-id="element-254" data-mp="3dabubvbwjva9" />}
      <PricingSection data-id="element-255" data-mp="3dalh7a1nhmbq" />
      <TestimonialsSection data-id="element-256" data-mp="3db3l8suk14u7" />
      <GuaranteeSection data-id="element-257" data-mp="3dcenupc9k6jq" />
      <FAQSection data-id="element-258" data-mp="3i9on0wpgfwkr" />
      <FinalCTA data-id="element-259" data-mp="3ia7utkle54l2" />
      <Footer data-id="element-260" data-mp="3i8n1tzeq5tpb" />
      {showPurchaseNotifications && <PurchasePopup data-id="element-261" data-mp="3n8hsc1ul8h9u" />}
    </main>;
}